var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"gutter":10}},[_c('el-col',{staticClass:"mb-10px",attrs:{"xs":24,"sm":10}},[_c('rapid-test-statistic')],1),_c('el-col',{attrs:{"xs":24,"sm":14}},[_c('rapid-test-detail')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }